module.exports = "<div class=\"resource-item-content resource-reel-item\">\r\n    <h3>Welcome Academic user!</h3>    \r\n    <p>These are the features you can use ....</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/partials/overview-resource-academic.html
// module id = 379
// module chunks = 1